export default __webpack_public_path__ + "media/portrait/logo_emirates-1a8df985.svg";